import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  SimpleGrid,
  FormErrorMessage,
} from '@chakra-ui/react';
import { useTranslation } from 'i18n/TranslationProvider';

const AddEditDriverModal = ({ isOpen, onClose, onSave, driver }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState(driver || {});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (isOpen) {
      setErrors({}); // clear errors when modal opens

      setFormData(
        driver
          ? {
              ...driver,
            }
          : {
              firstName: '',
              lastName: '',
              phone: '',
            },
      );
    }
  }, [isOpen, driver]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: undefined,
      }));
    }
  };

  const handleSave = () => {
    const newErrors = {};

    if (!formData.firstName?.trim()) {
      newErrors.firstName = t('First name is required');
    }

    if (!formData.lastName?.trim()) {
      newErrors.lastName = t('Last name is required');
    }

    if (!formData.phone?.trim()) {
      newErrors.phone = t('Phone number is required');
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    onSave(formData);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {driver ? t('Edit driver') : t('Add driver')}
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <VStack spacing={4} align="stretch">
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
              {/* First Name */}
              <FormControl isRequired isInvalid={errors.firstName}>
                <FormLabel>{t('First Name')}</FormLabel>
                <Input
                  name="firstName"
                  value={formData.firstName || ''}
                  onChange={handleChange}
                  placeholder={t('Enter first name')}
                />
                <FormErrorMessage>{errors.firstName}</FormErrorMessage>
              </FormControl>

              {/* Last Name */}
              <FormControl isRequired isInvalid={errors.lastName}>
                <FormLabel>{t('Last Name')}</FormLabel>
                <Input
                  name="lastName"
                  value={formData.lastName || ''}
                  onChange={handleChange}
                  placeholder={t('Enter last name')}
                />
                <FormErrorMessage>{errors.lastName}</FormErrorMessage>
              </FormControl>
            </SimpleGrid>

            {/* Phone */}
            <FormControl isRequired isInvalid={errors.phone}>
              <FormLabel>{t('Phone Number')}</FormLabel>
              <Input
                name="phone"
                type="tel"
                value={formData.phone || ''}
                onChange={handleChange}
                placeholder={t('Enter phone number')}
              />
              <FormErrorMessage>{errors.phone}</FormErrorMessage>
            </FormControl>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            {t('Cancel')}
          </Button>
          <Button colorScheme="blue" onClick={handleSave}>
            {t('Save')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddEditDriverModal;
